module.exports = __webpack_public_path__ + "img/ic_arrow_white.3a98fa0e.svg";